<!-- START Top Navbar-->
<nav class="navbar topnavbar" role="navigation">
    <!-- START navbar header-->
    <div class="navbar-header">
        <a class="navbar-brand" href="#/">

            <div class="brand-logo">
                <img class="img-fluid" src="assets/img/logo.png" alt="App Logo" style="height:40px" />
            </div>
            <div class="brand-logo-collapsed">
                <img class="img-fluid" src="assets/img/logo.png" alt="App Logo" />
            </div>
        </a>
    </div>
    <!-- END navbar header-->
    <!-- START Left navbar-->
    <ul class="navbar-nav mr-auto flex-row">
        <li class="nav-item">
            <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
            <a class="nav-link d-none d-md-block d-lg-block d-xl-block" trigger-resize="" (click)="toggleCollapsedSideabar()" *ngIf="!isCollapsedText()">
                <em class="fas fa-bars"></em>
            </a>
            <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->
            <a class="nav-link sidebar-toggle d-md-none" (click)="settings.toggleLayoutSetting('asideToggled'); $event.stopPropagation()">
                <em class="fas fa-bars"></em>
            </a>
        </li>
        <!-- START User avatar toggle-->
        <li class="nav-item d-none d-md-block">
            <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
            <a  class="nav-link" (click)="toggleUserBlock($event)">
                <em class="icon-user"></em>
            </a>
        </li>
        <!-- END User avatar toggle-->
        <!-- START lock screen-->
        <li class="nav-item d-none d-md-block">
            <a class="nav-link"  title="Lock screen" [routerLink]="'/lock'">
                <em class="icon-lock"></em>
            </a>
        </li>
        <!-- END lock screen-->
    </ul>
    <!-- END Left navbar-->
    <!-- START Right Navbar-->
    <ul class="navbar-nav flex-row">

      <!-- START Alert menu-->
      <!--<li class="dropdown dropdown-list" dropdown>-->
      <li class="dropdown dropdown-list" dropdown style="margin-top:13px;color:white;font-weight:bold">
        <a dropdownToggle>
          {{username}}
          <span class="caret"></span>
        </a>
        <!-- START Dropdown menu-->
        <ul *dropdownMenu class="dropdown-menu animated flipInX">
          <li>
            <!-- START list group-->
            <div class="list-group">
              <a class="list-group-item" [routerLink]="['/quantri/doimatkhau']">
                <div class="media">
                  <div class="align-self-start mr-2">
                    <i class="fa fa-exchange"></i>
                  </div>
                  <div class="media-body clearfix">
                    <p class="m0">Đổi mật khẩu</p>
                    <p class="m0 text-muted">
                      <small>Thay đổi mật khẩu tài khoản</small>
                    </p>
                  </div>
                </div>
              </a>
              <a class="list-group-item" (click)="logout()">
                <div class="media">
                  <div class="align-self-start mr-2">
                    <i class="fa fa-external-link"></i>
                  </div>
                  <div class="media-body clearfix">
                    <p class="m0">Đăng xuất</p>
                    <p class="m0 text-muted">
                      <small>Thay tài khoản</small>
                    </p>
                  </div>
                </div>
              </a>

            </div>
            <!-- END list group-->
          </li>
        </ul>
        <!-- END Dropdown menu-->
      </li>
      <!-- END Alert menu-->
      <!-- Search icon-->
      <!--<li class="nav-item">
        <a class="nav-link" (click)="openNavSearch($event)">
          <em class="icon-magnifier"></em>
        </a>
      </li>-->
      <!-- Fullscreen (only desktops)-->
      <li class="nav-item d-none d-md-block">
        <a class="nav-link" #fsbutton (click)="toggleFullScreen($event)">
          <em class="fa fa-expand"></em>
        </a>
      </li>


      <!-- START Offsidebar button-->

      <li class="nav-item">
        <!--<a class="nav-link" (click)="toggleOffsidebar(); $event.stopPropagation()">
      <em class="icon-notebook"></em>
    </a>-->
      </li>

      <!-- END Offsidebar menu-->
    </ul>
    <!-- END Right Navbar-->

    <app-navsearch [visible]="getNavSearchVisible()" (onclose)="setNavSearchVisible(false)"></app-navsearch>

</nav>
<!-- END Top Navbar-->
